export default __webpack_public_path__ + "static/media/Destribution-img.82915292.svg";